import { SHOW_LOADER, HIDE_LOADER } from "../actions/types.js";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
    case HIDE_LOADER:
    default:
      return state;
  }
}
